import { useEffect, useState } from 'react';

/**
 * CSS のメディアクエリを JS 側から見る。
 *
 * ホバーの有無や画面の向きは、CSS だけでは表現できない挙動（アフォーダンスの
 * 出し分け、案内の表示）にも影響するので、同じ条件を JS からも参照できるようにする。
 *
 * matchMedia が無い環境（古いjsdom等）では false を返す。
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(query).matches === true
  );

  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    setMatches(mq.matches);
    const onChange = (e) => setMatches(e.matches);
    // Safari 14 未満は MediaQueryList が EventTarget ではなく addEventListener が無い
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, [query]);

  return matches;
}
